<template>
  <div>
    <b-row style="margin-top: -25px">
      <b-col md="8"> </b-col>
      <b-col md="4">
        <div>
          <b-modal
            id="organizationEdit"
            title="Organization Details"
            header-class="header-nipige-class"
            size="lg"
            centered
            hide-footer
          >
            <sorganizationmodel
              :orgoListData="orgoAccessLists"
              @place_changed="setPlace"
              class="mt-3 ml-1"
            >
              <template v-slot:footer-button="data">
                <b-row class="mt-3">
                  <b-col md="8"></b-col>
                  <b-col md="4">
                    <b-button
                      class="btn btn-block"
                      btn-color="primary"
                      @click="OrgToNext(data.data)"
                    >
                      Update</b-button
                    >
                  </b-col>
                  <!-- <b-col md="4"></b-col> -->
                </b-row>
              </template>
            </sorganizationmodel>
          </b-modal>
          <b-button
            v-b-modal.organizationEdit
            class="main-navigation-button w-1 edit_button"
            style="margin-left: auto; display: block"
            variant="white"
            btn-color="primary1"
          >
            <v-avatar class="ml-n2 mt-n1" size="35">
              <img src="img/Edit.png" />
            </v-avatar>
          </b-button>
        </div>
      </b-col>
    </b-row>
    <div class="ml-2 mt-2">
      <div class="my-content">
        <b-row
          style="margin-top: -5px"
          class="mt-n2"
          v-if="orgoData.organization.registrationNo"
        >
          <b-col md="4">
            <h4 style="margin-top: -36px">Registration No :</h4>
          </b-col>
          <b-col md="4"
            ><h5 class="text-muted ml-n4" style="margin-top: -34px">
              {{ orgoData.organization.registrationNo }}
            </h5></b-col
          >
        </b-row>
        <b-row class="mt-n4" v-if="orgoData.organization.gstNo">
          <b-col md="4">
            <h4>GST No :</h4>
          </b-col>
          <b-col md="4"
            ><h5 class="text-muted ml-n4">
              {{ orgoData.organization.gstNo }}
            </h5></b-col
          >
        </b-row>
        <b-row class="mt-n4" v-if="orgoData.organization.fssciNo">
          <b-col md="4">
            <h4>FSSCI No :</h4>
          </b-col>
          <b-col md="4"
            ><h5 class="text-muted ml-n4">
              {{ orgoData.organization.fssciNo }}
            </h5></b-col
          >
        </b-row>
        <b-row style="margin-top: 5px" class="mt-n4">
          <b-col md="4">
            <h4>Location :</h4>
          </b-col>
          <b-col md="4"
            ><h5 class="text-muted ml-n4">
              {{ orgLocation }}
            </h5></b-col
          >
        </b-row>
        <b-row style="margin-top: 5px" class="mt-n2">
          <b-col md="4">
            <h4 style="margin-top: -10px">Access Level :</h4>
          </b-col>
          <b-col md="6"
            ><h5 class="text-muted ml-n4" style="margin-top: -7px">
              {{ orgoAccessLevelName }}
            </h5></b-col
          >
        </b-row>
        <b-row
          style="margin-top: -5px"
          class="mt-n2"
          v-if="!orgoAccessLists.length == 0"
        >
          <b-col md="4">
            <p class="text-style">orgAccessList :</p>
          </b-col>
          <b-col md="6">
            <ul style="margin-left: -25px">
              <li
                class="list-style1"
                v-for="items in orgoAccessLists"
                :key="items[0]._id"
              >
                {{ items[0].userName }}
              </li>
            </ul>
          </b-col>
        </b-row>
        <b-row class="mt-n4">
          <b-col md="4">
            <h4>Own Company :</h4>
          </b-col>
          <b-col md="4">
            <h5 class="text-muted ml-n4">
              {{ orgoData.organization.isOwnCompany }}
            </h5>
          </b-col>
        </b-row>
        <b-row style="margin-top: -5px" class="mt-n2">
          <b-col md="4" style="margin-top: -15px">
            <h4>Office :</h4>
          </b-col>
          <b-col md="6">
            <h5 class="text-muted ml-n4 mb-n2" style="margin-top: -1px">
              {{ officeData }}
            </h5>
            <h5 class="text-muted ml-n4" style="margin-right: 91px">
              {{ orgoData.office.address.houseNumber }}
              {{ orgoData.office.address.street1 }}
              {{ orgoData.office.address.city }},
              {{ orgoData.office.address.state }} ,{{
                orgoData.office.address.country
              }}, {{ orgoData.office.address.zip }}
            </h5>
          </b-col>
          <b-col md="2">
            <div>
              <b-modal
                id="officeEdit"
                title="Office"
                header-class="header-nipige-class"
                size="lg"
                centered
                hide-footer
              >
                <sofficemodel>
                  <template v-slot:footer-button="data">
                    <b-button
                      class="btn btn-block mt-3"
                      btn-color="primary"
                      @click="OfficeToNext(data.data)"
                      >Update</b-button
                    >
                  </template>
                </sofficemodel>
              </b-modal>
              <b-button
                v-b-modal.officeEdit
                class="main-navigation-button w-1"
                variant="white"
                style="margin-left: auto; display: block; margin-top: -22px"
                btn-color="primary1"
                ><v-avatar class="ml-n2 mt-n1" size="35">
                  <img src="img/Edit.png" /> </v-avatar
              ></b-button>
            </div>
          </b-col>
        </b-row>
        <b-row style="margin-top: -5px" class="mt-n3">
          <b-col md="4">
            <h4 style="margin-top: -1px">Office Phone :</h4>
          </b-col>
          <b-col md="6">
            <h5
              class="text-muted ml-n4"
              style="margin-top: -1px"
              v-for="item in orgoData.office.phone"
              :key="item._id"
            >
              {{ partnerAllData.authentication.phone }}
            </h5>
          </b-col>
        </b-row>
        <b-row style="margin-top: -5px" class="mt-n3">
          <b-col md="4">
            <h4 style="margin-top: -1px">Office Email :</h4>
          </b-col>
          <b-col md="6">
            <h5
              class="text-muted ml-n4"
              style="margin-top: -1px"
              v-for="item in orgoData.office.email"
              :key="item._id"
            >
              {{ partnerAllData.authentication.email }}
            </h5>
          </b-col>
        </b-row>
      </div>
      <div class="mobile-responsive">
        <b-row>
          <b-col md="4">
            <h4 style="margin-top: -25px; margin-left: -15px">
              Registration No :
            </h4>
          </b-col>
          <b-col md="4"
            ><h5
              class="text-muted"
              style="margin-left: 111px; margin-top: -48px"
            >
              {{ orgoData.organization.registrationNo }}
            </h5></b-col
          >
        </b-row>
        <b-row>
          <b-col md="4">
            <h4 style="margin-top: -25px; margin-left: -15px">GST No :</h4>
          </b-col>
          <b-col md="4"
            ><h5
              class="text-muted"
              style="margin-left: 111px; margin-top: -48px"
            >
              {{ orgoData.organization.gstNo }}
            </h5></b-col
          >
        </b-row>
        <b-row>
          <b-col md="4">
            <h4 style="margin-top: -25px; margin-left: -15px">FSSAI No :</h4>
          </b-col>
          <b-col md="4"
            ><h5
              class="text-muted"
              style="margin-left: 111px; margin-top: -48px"
            >
              {{ orgoData.organization.fssciNo }}
            </h5></b-col
          >
        </b-row>
        <b-row>
          <div>
            <b-col
              ><h4 style="margin-top: -17px; margin-left: -15px">
                Location :
              </h4></b-col
            >
            <b-col
              ><h5
                class="text-muted"
                style="margin-left: 82px; margin-top: -47px"
              >
                {{ orgLocation }}
              </h5></b-col
            >
          </div>
        </b-row>
        <b-row>
          <div>
            <b-col>
              <h4 style="margin-top: -25px; margin-left: -15px">
                Access Level:
              </h4>
            </b-col>
            <b-col
              ><h5
                class="text-muted"
                style="margin-left: 111px; margin-top: -48px"
              >
                {{ orgoAccessLevelName }}
              </h5></b-col
            >
          </div>
        </b-row>
        <b-row>
          <div>
            <b-col>
              <h4 style="margin-top: -36px; margin-left: -15px">Office :</h4>
            </b-col>

            <b-col>
              <h5
                class="text-muted"
                style="margin-left: 112px; margin-top: -56px"
              >
                {{ officeData }}
              </h5>
              <h5 class="text-muted" style="margin-left: 109px">
                {{ orgoData.office.address.houseNumber }}
                {{ orgoData.office.address.street1 }}
                {{ orgoData.office.address.city }},
                {{ orgoData.office.address.state }} ,{{
                  orgoData.office.address.country
                }}, {{ orgoData.office.address.zip }}
              </h5>
            </b-col>
            <b-col md="2">
              <div>
                <b-modal
                  id="modal-center-6"
                  title="Office"
                  header-class="header-nipige-class"
                  size="lg"
                  centered
                  hide-footer
                >
                  <sofficemodel>
                    <template v-slot:footer-button="data">
                      <b-button
                        class="btn btn-block mt-3"
                        btn-color="primary"
                        @click="OfficeToNext(data.data)"
                        >Save</b-button
                      >
                    </template>
                  </sofficemodel>
                </b-modal>
                <b-button
                  v-b-modal.modal-center-6
                  class="main-navigation-button w-1"
                  variant="white"
                  style="
                    margin-left: auto;
                    display: block;
                    margin-top: -124px;
                    margin-right: -11px;
                  "
                  btn-color="primary1"
                  ><v-avatar class="ml-n2 mt-n1" size="35">
                    <img src="img/Edit.png" /> </v-avatar
                ></b-button>
              </div>
            </b-col>
          </div>
        </b-row>
        <b-row>
          <div>
            <b-col>
              <h4 style="margin-top: -47px; margin-left: -15px">
                Office Phone :
              </h4>
            </b-col>
            <b-col>
              <h5
                class="text-muted"
                style="margin-top: -68px; margin-left: 102px"
                v-for="item in orgoData.office.phone"
                :key="item._id"
              >
                {{ item.number }}
              </h5>
            </b-col>
          </div>
        </b-row>
        <b-row>
          <div>
            <b-col>
              <h4 style="margin-top: -62px; margin-left: -15px">
                Office Email :
              </h4>
            </b-col>
            <b-col>
              <h5
                class="text-muted"
                style="margin-left: 110px; margin-top: -83px"
                v-for="item in orgoData.office.email"
                :key="item._id"
              >
                {{ item.mailId }}
              </h5>
            </b-col>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import { HeaderDropdown as AppHeaderDropdown } from "@/components";
import { getReverseGeoCode } from "@/services/geocode";
import sorganizationmodel from "@/components/Partner/PartnerEdit/OrganizationStepper";
import sofficemodel from "@/components/Partner/PartnerEdit/OfficeStepper";
import { mapGetters } from "vuex";
export default {
  name: "orgView",
  props: ["orgoData"],
  data() {
    return {
      dialog: false,
      orgLocation: null,
      position: {
        lat: 0,
        lng: 0,
      },
      orgoAccessLists: null,
    };
  },
  mounted() {
    console.log("orgoData", this.orgoData);
  },
  components: {
    AppHeaderDropdown,
    sorganizationmodel,
    sofficemodel,
  },
  computed: {
    ...mapGetters({ partnerAllData: "partner/GetPartnerData" }),
    orgoAccessLevelName() {
      if (this.orgoData.authorization.orgAccess) {
        return this.orgoData.authorization.orgAccess.orgAccessLevel;
      } else {
        return "";
      }
    },
    officeData() {
      if (this.orgoData.office) {
        return this.orgoData.office.officeName;
      } else {
        return null;
      }
    },
    orgoAccessListAll() {
      if (
        this.orgoData.authorization.orgAccess &
        this.orgoData.authorization.orgAccessList
      ) {
        return this.orgoData.authorization.orgAccess.orgAccessList;
      } else {
        return "";
      }
    },
    orgAccessListOptions() {
      let data = this.$store.getters["partner/GetPartnerList"];
      let tenantList = [];
      try {
        if (Array.isArray(data) && data.length > 0) {
          data.map((obj) => {
            if (obj.category === "OFFICE") {
              let arrayObj = {
                _id: obj._id,
                userName: obj.authentication.userName,
                email: obj.authentication.email,
                phone: obj.authentication.phone,
                password: "",
                ...obj,
              };
              tenantList.push(arrayObj);
            }
          });
          return tenantList;
        } else {
          return [];
        }
      } catch (err) {}
    },
  },
  methods: {
    async OrgToNext(data) {
      console.log("orgo Data", data);
      if (data.logo == "") {
        data.logo = this.orgoData.organization.logo.url;
      } else {
        data.logo = data.logo;
      }

      //   let cordinatess = [];
      //   cordinatess.push(this.position.lng);
      //   cordinatess.push(this.position.lat);
      //   data.location = {
      //     coordinates: cordinatess
      //   };

      //   data.location = cordinatess;
      let authorization = {};
      let orgaccess = [];
      if (data.orgAccessList !== null && data.orgAccessList.length > 0) {
        data.orgAccessList.map((obj) => {
          orgaccess.push(obj._id);
        });
      }

      authorization.orgAccess = {
        orgAccessLevel: data.orgAccessLevel.value,
        orgAccessList: orgaccess,
      };

      delete data.orgAccessLevel;
      delete data.orgAccessList;

      try {
        const payload = {
          id: this.partnerAllData._id,
          data: {
            authorization,
            organization: data,
          },
        };
        await this.$store.dispatch("partner/updatePartner", payload);
        this.$swal({
          title: "Success",
          text: "Partner Edited successfully!",
          type: "success",
        });
        this.$root.$emit("bv::hide::modal", "organizationEdit", "#btnShow");
      } catch (e) {
        this.$swal({
          title: "Error",
          text: "Could not Edited partner",
          type: "error",
        });
      }
    },
    async OfficeToNext(data) {
      // this.$emit("officeData", data);
      console.log("offfice all data", data);

      //   try {
      //     const dataVal = await getReverseGeoCode(
      //       `${data.address.street1},${data.address.city},${data.address.state},${data.address.country}`
      //     );
      //     //console.log("bill to loc", dataVal);
      //     if (dataVal.data.status === "OK") {
      //       data.address.location.coordinates = [
      //         dataVal.data.results[0].geometry.location.lng,
      //         dataVal.data.results[0].geometry.location.lat
      //       ];
      //       //console.log("office to loc", data);
      //     }
      //   } catch (error) {}

      let payload = {
        id: this.partnerAllData._id,
        data: {
          office: data,
          category: data.category.value,
        },
      };

      this.$store
        .dispatch("partner/updatePartner", payload)
        .then((result) => {
          console.log("result : ", result);
          this.$swal({
            title: "Success",
            text: "Partner Edited successfully!",
            type: "success",
          });
          this.$root.$emit("bv::hide::modal", "officeEdit", "#btnShow");
        })
        .catch((error) => {
          console.log(error);
          this.$swal({
            title: "Error",
            text: "Could not Edited partner",
            type: "error",
          });
        });
    },
    async setPlace(p) {
      let place = await p;
      let position = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.position = position;
    },
    isUrlValid(userInput) {
      try {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        );
        if (res == null) return false;
        else return true;
      } catch (err) {}
    },
  },
  async created() {
    if (!this.$store.getters["partner/GetPartnerList"].length) {
      this.$store.dispatch("partner/fetchPartnersList");
    }
    // let data1 = this.$store.getters["partner/GetPartnerList"];
    // console.log("data1", data1);
    console.log(this.orgoData.authorization.orgAccess.orgAccessLevel);
    let orgoAccessListlNames = [];
    if (this.orgoData.authorization.orgAccess.orgAccessList) {
      this.orgoData.authorization.orgAccess.orgAccessList.forEach((element) => {
        let singleorgoAccessListData = this.orgAccessListOptions.filter(
          (obj) => obj._id == element
        );
        orgoAccessListlNames.push(singleorgoAccessListData);
      });
    }
    this.orgoAccessLists = orgoAccessListlNames;
    console.log("this.orgAccessListOptions", this.orgAccessListOptions);
    console.log("orgoAccessListlNames", orgoAccessListlNames);
    try {
      const data = await getReverseGeoCode(
        `${this.orgoData.office.address.street1},${this.orgoData.office.address.city},${this.orgoData.office.address.state},${this.orgoData.office.address.country}`
      );
      if (data.data.status === "OK") {
        console.log("geocoderesult", data);
        this.orgLocation = data.data.results[0].formatted_address;
      }
    } catch (error) {}
    // if (Array.isArray(data) && data.length > 0) {
    //   data.map(obj => {
    //     if (obj.category === "OFFICE") {
    //       let arrayObj = {
    //         _id: obj._id,
    //         userName: obj.authentication.userName,
    //         email: obj.authentication.email,
    //         phone: obj.authentication.phone,
    //         password: "",
    //         ...obj
    //       };
    //       tenantList.push(arrayObj);
    //     }
    //   });
    // } else {
    //   console.log("nooooooooooooo");
    // }
    // console.log("tenantList", tenantList);
  },
};
</script>
<style scoped>
.text-style {
  font-family: 'Lato';
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  /* or 138% */

  letter-spacing: 0.15px;

  color: rgba(143, 143, 143, 0.87);
}
.list-style {
  list-style-type: none;
  text-align: left;
}
.list-style1 {
  list-style-type: none;
  text-align: left;
  display: inline;
}

[btn-color="primary1"] {
  outline: none !important;
  border-radius: 50%;
  height: 39px;
  width: 39px;
  margin-left: 10px;
}

[btn-special="primary1"] {
  border-radius: 50%;
}

.header-style {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
}
@media (max-width: 767px) {
  .my-content {
    display: none;
  }
}
@media (min-width: 767px) {
  .mobile-responsive {
    display: none;
  }
}
@media (max-width: 767px) {
  .edit_button {
    margin-top: -30px;
    margin-right: -12px;
  }
}
</style>
